import BaseEntity from '@/core/misc/BaseEntity';

export default class CharacteristicAllowedValue extends BaseEntity {
	name: string;

	static fromServer(data: any, allowedValue: CharacteristicAllowedValue = new CharacteristicAllowedValue()): CharacteristicAllowedValue {
		super.fromServer(data, allowedValue);

		return allowedValue;
	}
}